import gql from 'graphql-tag';

export default gql`
  mutation saveVendorVariant(
    $vendorVariantId: ID!
    $boardId: ID
  ) {
    saveVendorVariant(
      vendorVariantId: $vendorVariantId,
      boardId: $boardId
    ) {
      id
    }
  }
`;
